import { fromJS, Record } from 'immutable';
import { omitBy } from 'lodash';
import {
  generateKeys,
  generateSchema,
  hasValue,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { Reference } from '../../document-data/sub-models/reference.model';
import { IModelValidator } from '../../shared/interfaces/model-validator.interface';

export const CLIENT_REFERENCE_SCHEMA = Object.freeze({
  REFERENCE: null, // Reference
});
const RECORD = generateSchema(CLIENT_REFERENCE_SCHEMA);
const KEYS: any = generateKeys(CLIENT_REFERENCE_SCHEMA);

export class ClientReference extends Record(RECORD) implements IModelValidator {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    return setInModel(this, [
      {
        key: KEYS.REFERENCE,
        value: props.get(KEYS.REFERENCE) ? new Reference(this.reference) : null,
      },
    ]) as ClientReference;
  }

  get reference(): Reference {
    return this.get(KEYS.REFERENCE);
  }

  get id(): string {
    return this.reference.id;
  }

  hasValue(): boolean {
    const hasFieldsPopulated = hasValue(
      KEYS,
      omitBy(
        CLIENT_REFERENCE_SCHEMA,
        (_, key) => key.toLowerCase() === KEYS.REFERENCE.toLowerCase()
      ),
      this.toMap()
    );

    return (
      hasFieldsPopulated || (!!this.reference && this.reference.hasValue())
    );
  }
}
